import { watch, type ComputedRef, type Ref } from 'vue'

/**
 * 조건이 참일때 api를 한번만 호출하는 함수입니다.
 *
 * @param fetchFunction api 요청을 보내는 함수입니다.
 * @param condition condition이 true면 api요청을 보냅니다.
 * @param res response를 사용해야 할 필요가 있다면,,,
 */
export function useConditionalFetch(
  fetchFunction: () => Promise<any> | any,
  condition: ComputedRef<boolean>,
  res?: Ref<any>,
) {
  const unwatch = watch(
    condition,
    async () => {
      if (condition.value) {
        const response = await fetchFunction()
        unwatch()
        if (res) res.value = response
      }
    },
    { immediate: true },
  )
}
